<template>
  <v-container :class="contClass">
    <apexchart
      type="pie"
      :options="options"
      :series="data"
      length="350px"
      :height="newHeight"

    ></apexchart>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: ['data', 'labels', 'title', 'customOptions', 'height'],
  computed: {
    ...mapGetters({
      _options: 'charts/getPieChart',
      client: 'account/getCurrentClient',
    }),
    options() {
      const options = { ...this._options };
      options.labels = this.labels;
      options.colors[0] = this.$vuetify.theme.currentTheme.primary;
      options.colors[1] = this.$vuetify.theme.currentTheme.secondary;
      return options;
    },
    contClass() {
      if (this.client.client_name === 'shark') {
        return 'pt-10';
      }
      return '';
    },
    newHeight() {
      if (this.height) {
        return this.height;
      }
      return '350px';
    },
  },
};
</script>
